import { Tooltip } from 'antd'

import ProductCatalogTitleCell from 'components/FieldRenderers/ProductCatalogTitleCell/ProductCatalogTitleCell'
import { Field } from 'types'

import { createField } from './createField'
import { FieldCreatorOptions } from './localTypes'

export function salesEstimatesTitle<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: 'title',
        name: 'Product',
        shortName: 'Product',
        minWidth: 200,
        dataIndex: options.dataIndex ?? ['title'],
        width: 300,
        renderOptions: {
            render: ({ value, record }: any) => {
                return (
                    <ProductCatalogTitleCell
                        value={value}
                        productImg={record.product_small_image_url}
                        size="small"
                        linkToProductDetails
                        productMarketplace={record.marketplace}
                        productAsin={record.asin}
                        titleFormatter={(val) => (
                            <Tooltip title={val}>{val}</Tooltip>
                        )}
                    />
                )
            },
        },
    })
}

export function salesEstimatesProductSmallImageUrl<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: 'product_small_image_url',
        name: 'Product Image URL',
        shortName: 'Product Image URL',
        dataIndex: options.dataIndex ?? ['product_small_image_url'],
        isVisible: false,
    })
}

export function salesEstimatesAsin<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: 'asin',
        name: 'ASIN',
        shortName: 'ASIN',
        dataIndex: options.dataIndex ?? ['asin'],
        isVisible: false,
    })
}

export function salesEstimatesMarketplace<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: 'marketplace',
        name: 'Marketplace',
        shortName: 'Marketplace',
        dataIndex: options.dataIndex ?? ['marketplace'],
        width: 130,
    })
}
